import type { SVGProps } from "react";

export default function SortingDefaultIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M13.3333 14.9998V4.99976M13.3333 4.99976L16.6667 8.43726M13.3333 4.99976L10 8.43726"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66683 4.99976V14.9998M6.66683 14.9998L10.0002 11.5623M6.66683 14.9998L3.3335 11.5623"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
